
export const dataListFilter = {
    "来源": ["全部", "真题", "机经", "其他"], 
    "频率": ["全部", "高频", "非高频"],
    "练习状态": ["全部", "练习过", "未练习"],
    "收藏状态": ["全部", "收藏", "未收藏"]
}
export const dataListSort = ["题号", "频率", "新增", "更新"]

